import Vue from 'vue';
import VueRouter from 'vue-router';
import Fragment from 'vue-fragment';

import { routes as newsroomRoutes } from './Modules/Newsroom/index';
import { routes as journeyRoutes } from './Modules/JourneyBuilder/index';
import { routes as ioFormatRoutes } from './Modules/IoFormat/index';
import { routes as pushNotificationRoutes } from './Modules/PushNotifications/index';

export default (selector) => {
    //Remove after Vue3 upgrade
    //syntax should be the same
    Vue.use(Fragment.Plugin);
    
    Vue.use(VueRouter);
    
    const router = new VueRouter({
        //History mode should always be used due to the way routing has been initially setup within the system
        mode: 'history',
        routes: [
            ...newsroomRoutes,
            ...journeyRoutes,
            ...pushNotificationRoutes,
            ...ioFormatRoutes
        ]
    });
    
    const noop = () => {};
    
    const interceptExternalLinkClick = (event) => {
        //event.currentTarget.pathname?
        const href = event.currentTarget.attributes.href.value;
        const isMatch = !!router.match(href).matched.length;
        
        //Actual links should be let through
        if(!isMatch) return;
        
        //Links that can handled by our router should be handled by our router
        //no need for unnecessary page loads
        event.preventDefault();
        
        router.push(href)
            .then(noop, noop);
    };

    //Attach a custom click handler to all anchor tags pre-vue init
    //vue renders router-links as 'a' tags by default
    //there should never be a need to intercept those
    document.querySelectorAll('a[href]:not([href="#"])')
        .forEach(node => node.addEventListener('click', interceptExternalLinkClick));
    
    router.beforeEach((to, from, next) => {
        //MVC routes might be included in our path
        //once encountered; we should give back control to MVC
        if(to.meta && to.meta.isMvcRoute){
            window.location.href = to.fullPath;
            return;
        }

        next();
    });
    
    router.afterEach((to, from) => {
        //MVC path, return to ye ol' MVC routing
        if(to.matched.length === 0) {
            window.location.href = to.fullPath;
        }
    });
    
    router.afterEach((to, from) => {
        //https://alligator.io/vuejs/vue-router-modify-head/
        //https://stackoverflow.com/a/58716613 
        const nearestWithTitle = [...to.matched].reverse()
            .find(r => r.meta && r.meta.title);
        
        if(nearestWithTitle) {
            document.title = nearestWithTitle.meta.title;   
        }
    });
    
    new Vue({
        router: router
    }).$mount(selector);
};